<template>
  <el-container style="display:block">
    <el-row style="width: 100%;height:70%" class="message">
      <el-card >
        <div slot="header" class="systemMessage-title">
        <span>系统消息</span>
      </div>
       <div v-if="systemMessageList.length<=0">
        <div class="el-nomessage">
          <div></div>
          <span>无系统消息</span>
        </div>
       </div>
       
      <div v-for="(item, index) of systemMessageList" v-else :key="index">
          <el-row @mouseover.native="mouseoverMessage(item)" @mouseout.native="mouseleaveMessage(item)" style="white-space: nowrap;">
            <i v-if="item.messageLevel === 1" :style="item.didRead==0 ? '':'color:#D3D3D3 !important;'" class="el-icon-s-comment"></i>
            <i v-if="item.messageLevel === 2" :style="item.didRead==0 ? '':'color:#D3D3D3 !important;'" class="el-icon-warning"></i>
            <i v-if="item.messageLevel === 3" :style="item.didRead==0 ? '':'color:#D3D3D3 !important;'" class="el-icon-question"></i>
            <el-button type="text" :style="item.didRead==0 ? '':'color:#D3D3D3;padding-left:0px !important;'" @click="readMessage(item)" style="text-align:left;width:330px;overflow: hidden;white-space: nowrap;text-overflow:ellipsis !important;">{{item.messageTitle}}</el-button>
            <i class="el-icon-close"  v-show="item.showDeleteIcon" style="position: absolute;z-index:999;right:10px;margin-top: 10px;" @click="deleteMessage(item.id)"></i>
          </el-row>
      </div>
    </el-card>
    </el-row>
    <el-row style="width:100%;height:30%;overflow:hidden">
       <el-card class="box-card" style="font-size: 14px;height:30%;">
         <div slot="header" class="systemMessage-title">
        <span>我要咨询 </span>
      </div>
        <div class="consultingService" v-if="agentPhone">
         <span class="csTitle"> <img src="@/assets/images/phone.png" class="consult-icon"><span>代理商：</span></span><span style="color:#888888">{{agentName}}    &nbsp; {{agentPhone}} </span>
        </div>
        <div class="consultingService" v-if="bcName">
         <span class="csTitle"><img src="@/assets/images/phone.png" class="consult-icon"> <span>业务顾问：</span></span><span style="color:#888888">{{bcName}}    &nbsp; {{bcPhone}} </span>
        </div>
        <div class="consultingService">
          <span class="csTitle"> <img src="@/assets/images/phone.png" class="consult-icon"><span>平台咨询电话：</span></span><span style="color:#888888">{{serviceTel}}</span>
        </div>
        <div class="consultingService">
          <span class="csTitle"><img src="@/assets/images/email.png" class="consult-icon"><span>平台咨询邮箱：</span> </span><span style="color:#888888">{{serviceEmail}}</span>
        </div>
      </el-card>
    </el-row>
     <message-detail></message-detail>
  </el-container>
</template>


<script>
  import MessageDetail from './systemMessage_detail'
  import { getCookie,setCookie } from '@/utils/cookie'
    import axios from 'axios'
  export default {
    name: "systemMessage",
    components: {MessageDetail},
    data() {
      return {
        systemMessageList: [],
        serviceTel:'',
        serviceEmail:'',
        agentName:'',
        agentPhone:'',
        bcName:'',
        bcPhone:'',
      }
    },
    methods: {
      getServiceInfo(){
        axios.get(this.common.urlPrefix +'/static/json/serviceInfo.json').then(response => {
         this.serviceTel = response.data.service_tel.name;
         this.serviceEmail = response.data.service_email.name;
        })
        this.common
            .httpPost(
              '获取代理人信息',
              '/admin/home/enterprise/getConsultingService',
              {}
            ) 
            .then((res) => {
             this.agentName = res.agentName;
             this.agentPhone = res.agentPhone;
              this.bcName = res.bcName;
             this.bcPhone = res.bcPhone;
            })
      },
      // 点击某条系统消息
       readMessage(systemMessage){
         this.eventBus.$emit("showMessageDetail", systemMessage);
         if(systemMessage.didRead==0){
            //修改该条信息状态为已读
            this.common
            .httpPost(
              '修改消息状态为已读',
              '/admin/system/systemMessages/updateMessageStatus',
              {"id":systemMessage.id},true
            )
            .then((res) => {
                if(res!=undefined){
                  //通知head刷新数据
                  this.$store.dispatch("initUpdateMessageStatus",!this.$store.getters.updateMessageStatus)
                }
            })
         }
       },
      // 删除某条系统消息
      deleteMessage(systemMessageId){
        this.$confirm('您确定要删除当前系统消息吗？', '信息确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          //根据ID删除系统消息
           this.common
        .httpPost(
          '根据ID删除系统消息',
          '/admin/system/systemMessages/deleteMessage',
          {"id":systemMessageId}
        )
        .then((res) => {
            if(res!=undefined){
              //通知head刷新数据
              this.$store.dispatch("initUpdateMessageStatus",!this.$store.getters.updateMessageStatus)
            }
        })
        })
        .catch(() => {
        })
      },
      // 鼠标悬停某条系统消息
      mouseoverMessage(item){
        var title = item.messageTitle + ' ';
          item.showDeleteIcon = true;
        item.messageTitle=title;
      },
      // 鼠标离开某条系统消息
      mouseleaveMessage(item){
        var title = item.messageTitle;
        item.showDeleteIcon = false;
        item.messageTitle = title.trim();
      },
    },
     computed: {
        getMessageList () {
          return this.$store.getters.systemMessageList
        },
        
    },
    watch:{
        //监听获取最新的消息列表
        getMessageList(newVal,oldVal){
        this.systemMessageList=newVal
        for(var i=0;i<this.systemMessageList.length;i++){
              this.systemMessageList[i].showDeleteIcon=false
          }
      }
    },
    mounted(){
      this.systemMessageList=this.$store.getters.systemMessageList
      for(var i=0;i<this.systemMessageList.length;i++){
              this.systemMessageList[i].showDeleteIcon=false
          }
          this.getServiceInfo();
    }
  }
</script>

<style scoped>
.consult-icon{
  width: 18px;
  margin-right:6px
}
.csTitle{
  width:130px;
  display: inline-block;
  text-align: right;
  color:#606266
}
.consultingService{
  padding: 13px 0;
  width: 90%;
}
.main_content_right .el-icon-warning {
  width:16px;
  font-size: 0.14rem !important;
  color: #ff6537;
}
  .el-icon-s-comment {
    color: #2eb38f;
  }
  .el-icon-warning{
        margin-right: 0px !important;
  }
  .el-button{
    padding-left: 0px !important;
  }

  .el-icon-question{
    color: red;
  }
  .el-icon-close {
    color: #9e9fa2;
  }
  .el-icon-close:hover {
    cursor:pointer;
  }

  .el-button--text{
    color: #333;
  }

  .systemMessage-content-read {
    margin-left: 15px;
  }

  .systemMessage-content-notRead {
    margin-left: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/views/home/enterprise/systemMessage.vue